<template>
  <div class="pager d-flex justify-content-center">
    <!-- Lewa sekcja: przejście do pierwszej strony i poprzedniej strony -->
    <div class="prev">
      <button
        class="btn-prev"
        @click="firstPage()"
        :disabled="currentPage === 1"
      >
        &lt;&lt;
      </button>
      <button
        class="btn-prev"
        @click="previousPage()"
        :disabled="currentPage === 1"
      >
        &lt;
      </button>
    </div>
    <!-- Środkowa sekcja: input z numerem strony oraz liczba wszystkich stron -->
    <div class="pages">
      <input
        v-model="currentPage"
        size="2"
        type="text"
        @keyup.enter="setPage"
      />
      <span>/ {{ totalPages }}</span> <!-- Wyświetla ilość stron -->
    </div>
    <!-- Prawa sekcja: przejście do następnej i ostatniej strony -->
    <div class="next">
      <button
        class="btn-prev"
        @click="nextPage()"
        :disabled="currentPage === totalPages"
      >
        &gt;
      </button>
      <button
        class="btn-next ms-auto"
        @click="lastPage()"
        :disabled="currentPage === totalPages"
      >
        &gt;&gt;
      </button>
    </div>
  </div>
</template>

<script>
export default {
  mounted() {
    // Po zamontowaniu komponentu ustaw bieżącą stronę na pageNum z props
    this.currentPage = this.pageNum;
  },
  watch: {
    // Obserwuje zmianę pageNum z props i aktualizuje currentPage
    pageNum(newPage) {
      this.currentPage = newPage;
    },
  },
  props: {
    pageNum: { required: true },   // aktualnie wybrany numer strony (z rodzica)
    pageSize: { required: true },  // ile elementów na stronie
    totalSize: { required: true }, // łączna liczba elementów
  },
  name: "PagePanel",
  data() {
    return {
      currentPage: 1, // lokalny stan numeru strony
    };
  },
  computed: {
    // Liczy całkowitą liczbę stron
    totalPages() {
      return Math.ceil(this.totalSize / this.pageSize);
    },
  },
  methods: {
    // Ustaw stronę po wpisaniu numeru i kliknięciu Enter
    setPage() {
      const page = parseInt(this.currentPage);
      if (!isNaN(page) && page >= 1 && page <= this.totalPages) {
        this.currentPage = page;
        this.emit(); // emituje zdarzenie do rodzica
      } else {
        this.currentPage = this.pageNum; // jeśli wpisano błędną wartość, wraca do poprawnej
      }
    },
    // Przejście do pierwszej strony
    firstPage() {
      this.currentPage = 1;
      this.emit();
    },
    // Przejście do poprzedniej strony
    previousPage() {
      this.currentPage = parseInt(this.currentPage) - 1;
      this.emit();
    },
    // Przejście do następnej strony
    nextPage() {
      this.currentPage = parseInt(this.currentPage) + 1;
      this.emit();
    },
    // Przejście do ostatniej strony
    lastPage() {
      this.currentPage = this.totalPages;
      this.emit();
    },
    // Funkcja emitująca wybraną stronę do komponentu nadrzędnego
    emit() {
      this.$emit("setPage", this.currentPage);
    },
  },
};
</script>

<style scoped>
.pager {
  margin: 5px 0;
  font-size: 14px;
}
.pager .pages {
  margin: 0 15px;
}
.pager > div > button:first-child {
  border-right: 1px solid #b8b8b6;
}
.pager input {
  width: 40px;
  text-align: center;
  margin: 0 2px;
  padding: 0;
}
button {
  border: none;
  background: none;
}
</style>
